module.exports = __webpack_public_path__ + "img/bgc8.1b4345c7.png";